// Dynamic CSS and JS loader
(function() {
    // Get root path from script's data attribute
    const currentScript = document.currentScript || document.querySelector('script[data-root-path]');
    const rootPath = currentScript ? currentScript.getAttribute('data-root-path') : './';

    // Load CSS files dynamically
    const cssFiles = [
        'css/alert-info.css'
    ];

    cssFiles.forEach(file => {
        document.head.appendChild(Object.assign(document.createElement('link'), {
            rel: 'stylesheet',
            href: `${rootPath}${file}`
        }));
    });

    // Load JS files dynamically
    const jsFiles = [
        'js/alert-detect.js',
        'js/alert-info.js',
        'js/lazysizes.min.js'
    ];

    jsFiles.forEach(file => {
        const script = document.createElement('script');
        script.src = `${rootPath}${file}`;
        document.head.appendChild(script);
    });

    // Google Tag Manager
    (function(w,d,s,l,i){
        w[l]=w[l]||[];
        w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-NJRLM8');
})();